import React from "react";
import { Box, Typography } from "@mui/material";

const KpiCard = ({ title, value, subtext = "", color = "#4C4A8D" }) => {
  return (
    <Box
      sx={{
        flex: "1 1 200px",
        minWidth: 200,
        backgroundColor: "#fff",
        border: "1px solid #e0e0e0",
        borderRadius: "12px",
        padding: 2,
      }}
    >
      <Typography variant="body2" sx={{ color: "#666" }}>
        {title}
      </Typography>
      <Typography variant="h5" sx={{ fontWeight: "bold", color }}>
        {value}
      </Typography>
      {subtext && (
        <Typography variant="caption" sx={{ color: "#999" }}>
          {subtext}
        </Typography>
      )}
    </Box>
  );
};

export default KpiCard;
